import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';
import { Observable, of, throwError } from 'rxjs';
import { PatientDeviceDataModel } from '../models/enroll-patient-device-data.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class PatientFinderService {
    public token = localStorage.getItem('token');

    constructor(private apiService: ApiService) {}

    enrollPatientByDevice(deviceId, deviceSerialNumber, dob) {
        const params = new HttpParams()
            .set('deviceProductId', deviceId)
            .set('deviceSerialNumber', deviceSerialNumber)
            .set('dateOfBirth', dob?.toString());
        return this.apiService.get(
            ClinicianApiEndPointConstants.enrollPatientByDevice,
            params
        );
    }

    transferRequestApi(patientId) {
        return this.apiService.get(
            `${ClinicianApiEndPointConstants.getTransferRequestApi}/${patientId}/transfer`
        );
    }
    enrollPatientByIns(insNumber: string): Observable<PatientDeviceDataModel> {
        return this.apiService.get(
            `${ClinicianApiEndPointConstants.enrollPatientByIns}?insNumber=${insNumber}`
        ) as Observable<PatientDeviceDataModel>;
    }

    enrollPatientWithoutIns(request): Observable<PatientDeviceDataModel> {
        return this.apiService.get(
            `${ClinicianApiEndPointConstants.getTransferRequestApi}/fr-firstname-lastname-dob?firstName=${request.firstName}&lastName=${request.lastName}&dateOfBirth=${request.dateOfBirth}`
        ) as Observable<PatientDeviceDataModel>;
    }

    searchPatient(firstName, lastName, dob) {
        let params = new HttpParams()
            .set('firstName', firstName?.toString())
            .set('lastName', lastName?.toString())
            .set('dateOfBirth', dob?.toString());
        return this.apiService.get(
            `${ClinicianApiEndPointConstants.searchPatient}`,
            params
        );
    }
}
